import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Hero from "@/components/sections/Hero";
import Historia from "@/components/sections/Historia";
import LaPropiedad from "@/components/sections/LaPropiedad";
import Experiencias from "@/components/sections/Experiencias";
import Amenidades from "@/components/sections/Amenidades";
import Precios from "@/components/sections/Precios";
import Galeria from "@/components/sections/Galeria";
import Eventos from "@/components/sections/Eventos";
import AlaudaCta from "@/components/sections/AlaudaCta";
import Testimonios from "@/components/sections/Testimonios";
import FAQ from "@/components/sections/FAQ";
import Contacto from "@/components/sections/Contacto";

export default function Home() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <Hero />
      <Historia />
      <LaPropiedad />
      <Experiencias />
      <Amenidades />
      <Precios />
      <Galeria />
      <Eventos />
      <AlaudaCta />
      <Testimonios />
      <FAQ />
      <Contacto />
      <Footer />
    </div>
  );
}